import styled from 'styled-components/macro';
import { theme } from 'styled-tools';
import { Row } from 'reactstrap';

const ModuleCard = styled(Row)`
  flex-direction: row-reverse;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: stretch;
  border: 1px solid ${theme('colors.mediumGray')};
  border-radius: ${theme('borderRadius')};
  margin-bottom: 1rem;
  background: ${theme('colors.white')};

  & > div {
    flex-direction: column;
  }

  div {
    &.card-content {
      width: 100%;
    }
  }

  label {
    padding-top: 1rem;
    padding-bottom: 0.5rem;
    margin-bottom: 0;
    font-weight: ${theme('fontWeightBold')};
  }

  .col {
    margin-bottom: 0.5rem;
  }

  .col + .col {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid ${theme('colors.mediumGray')};
    margin-bottom: 0;
  }
`;

export default ModuleCard;
